module.exports = __webpack_public_path__ + "bc325a16c05be63fde238d2881ca1bc5.png";